import DateDisplay from 'components/DateDisplay';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the fault date.
 */
export default function FaultDateColumn({ data: { revision } }: { data: FaultRow }) {
  return revision?.finishedAt ? <DateDisplay date={new Date(revision.finishedAt)} withRelative={false} /> : '';
}
